import isNil from 'lodash.isnil';
import omitBy from 'lodash.omitby';
import { FormTemplate, FormTemplateSection } from 'data/template/template.types';
import { SecurityInfo } from 'data/securityInfo/securityInfo.types';

// eslint-disable-next-line import/prefer-default-export
export function createSecurityInfoBasedOnTemplate(
  template: FormTemplate,
): SecurityInfo {
  const securityInfo: Partial<SecurityInfo> = {
    ...getFieldValuesFromSection(template.main as FormTemplateSection),
  };

  return omitBy(securityInfo, isNil) as unknown as SecurityInfo;
}

function getFieldValuesFromSection(
  templateSection: FormTemplateSection,
): Partial<SecurityInfo> {
  return Object.entries(templateSection?.fields)
    .filter(([_fieldName, field]) => field.initial != null)
    .reduce((previousValue, [fieldName, field]) => ({
      ...previousValue,
      [fieldName]: field.initial,
    }), {});
}
